import React from 'react';
import Layout from '../../components/Layout';
import Home from './Home';

// TODO: remove the publication in DB instead of filtering in frontend
const filterPubList = ['Lighting Audio Visual Asia'];

async function action(context) {
  const { fetch } = context;
  const res = await fetch('/graphql', {
    body: JSON.stringify({
      query: `{publications{id, name, mast_head_uid, short_name}}`,
    }),
  });
  const { data } = await res.json();

  const publications = data.publications.filter(
    pub => !filterPubList.includes(pub.name),
  );

  const isDev = process.env.NODE_ENV !== 'production';
  const decorated = publications.map(p => ({
    ...p,
    url: isDev
      ? `/publications/${p.id}`
      : `http://${p.short_name}.tradelinkmedia.biz/publications/${p.id}`,
  }));

  return {
    chunks: ['home'],
    component: (
      <Layout>
        <Home publications={decorated} />
      </Layout>
    ),
  };
}

export default action;
